// src/components/ui/calendar/week/WeekViewHeader/WeekViewHeader.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';
import { CalendarDateHeader } from '../../core';

const WeekViewHeader = ({
  weekDates,
  currentDate,
  className = ''
}) => {
  console.log('🔍 WeekViewHeader received weekDates:', weekDates);
  console.log('🔍 WeekViewHeader received currentDate:', currentDate);

  if (weekDates) {
    weekDates.forEach((date, index) => {
      console.log(`🔍 Date ${index}:`, date, 'Type:', typeof date);
    });
  }

  const today = new Date().toDateString();

  return (
    <div className={cn(
      // Container with spacer for hour label column
      "flex bg-slate-800/40 border-b border-slate-600/30",
      className
    )}>
      {/* Spacer for hour label column */}
      <div className="w-14 flex-shrink-0" />

      {/* Week dates grid */}
      <div className="flex-1 grid grid-cols-7">
        {weekDates.map((date, index) => (
          <CalendarDateHeader
            key={index}
            date={date}
            view="week"
            isToday={date.toDateString() === today}
            isSelected={date.toDateString() === currentDate.toDateString()}
            className="border-r border-slate-600/30 last:border-r-0"
          />
        ))}
      </div>
    </div>
  );
};

export default WeekViewHeader;